module.exports = __webpack_public_path__ + "img/brand-future-man-bg-sm.68538b14.png";